/**
 * Accessory slot 3 of three. Trinkets, pouches and dosimeters: worn gear that shifts a stat or
 * carries a small plate rather than covering a hit location outright.
 */

import type { EquipmentSlot } from '@/sim/inventory/slotContract';

export const ACCESSORY_3_SLOT = {
  id: 'accessory3',
  label: 'Accessory 3',
  description: 'Worn gear that is not a plate: pouches, filters and charms.',
} as const satisfies EquipmentSlot;
